import React from 'react'
import styled from 'styled-components'

import { Button, TextField, FormField } from 'components'

const Container = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: auto auto;
    grid-gap: 0.5rem;
    margin-top: 0.2rem;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    grid-column: 1/ span 2;
`

const NameInput = props => {
    const {
        first_name,
        last_name,
        onSubmit,
        onCancel
    } = props;
    const [firstName, setFirst] = React.useState(first_name)
    const [firstNameError, setFirstError] = React.useState(null)
    const [lastName, setLast] = React.useState(last_name)
    const [selection, setSelection] = React.useState(null)

    const onKeyDownHandler = (event) => {
        if (event.keyCode === 13 ) {
            submitForm()
        }
    }

    const submitForm = ()  => {
        // First name
        if(!firstName || firstName.length === 0){
            setFirstError('Please input your first name')
        } else {
            onSubmit && onSubmit(firstName, lastName)
        }

    }

    return (
        <Container>
            {/* First name */}
            <FormField type='TEXT' label='First name' value={firstName} error={firstNameError} selected={selection==='firstName'}
                onChange={(value) => setFirst(value)} onKeyDown={onKeyDownHandler} style={{margin: 0, labelWeight: 'normal'}}
                onFocus={() => setSelection('firstName')}
                onBlur={() => setSelection(null)}/>

            {/* Last name */}
            <FormField type='TEXT' label='Last name' value={lastName} selected={selection==='lastName'}
                onChange={(value) => setLast(value)} onKeyDown={onKeyDownHandler} style={{margin: 0, labelWeight: 'normal'}}
                onFocus={() => setSelection('lastName')}
                onBlur={() => setSelection(null)}/>

            {/* Buttons */}
            <ButtonContainer>
                <Button text='Cancel' styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}} onSelect={onCancel}/>
                <Button text='Save' styles={{backgroundColor: 'var(--focus-color)', margin: 0, color: 'white'}} onSelect={submitForm}/>
            </ButtonContainer>
        </Container>
    )
}

export default NameInput